import React from "react";
import { AppList } from "components/list/AppList";
import { Datagrid, SelectField, TextField } from "react-admin";

import { DatagridWithBlockDeleteProps } from "../../../components/_helpers/props/DatagridProps";
import { useEnumSelectChoices } from "../../../components/_helpers/useEnumSelectChoices";
import { DateTimeField } from "../../../components/fields/DateFormatField";
import { ScrollingWrapper } from "../../../components/ScrollingWrapper";
import { AdminLogLevelType } from "../../../entities/AdminLogLevelType";
import { AdminLogModuleType } from "../../../entities/AdminLogModuleType";
import { AdminLogsDetails } from "../components/AdminLogsDetails";
import { AdminLogsFilter } from "./ListFilters";

const defaultSort = { field: "created_at", order: "DESC" };

export const AdminLogsList = (props) => {
	const adminLogLevelChoices = useEnumSelectChoices(AdminLogLevelType, "log-level");
	const adminModuleChoices = useEnumSelectChoices(AdminLogModuleType, "log-module");

	return (
		<AppList
			{...props}
			sort={defaultSort}
			exporter={false}
			bulkActionButtons={false}
			filters={<AdminLogsFilter />}
			// empty={<Empty/>}
		>
			<ScrollingWrapper>
				<Datagrid {...DatagridWithBlockDeleteProps} rowClick="show" expand={<AdminLogsDetails />}>
					<TextField source="id" sortable={false} />
					<DateTimeField source="created_at" withLocalTimeZone />
					<TextField source="order_id" />
					<SelectField source="log_level" choices={adminLogLevelChoices} />
					<SelectField source="module" choices={adminModuleChoices} />
					<TextField source="description" sortable={false} />
				</Datagrid>
			</ScrollingWrapper>
		</AppList>
	);
};
